export default __webpack_public_path__ + "static/media/18.7480a938.jpg";